/**
 * Custom AOS (Animate On Scroll)
 *
 * Lightweight IntersectionObserver-based scroll animations.
 * Adds 'custom-aos--in' class when elements enter viewport.
 *
 * Usage: <div data-custom-aos="fade-up" data-custom-aos-delay="200">
 *
 * Theme editor compatible with section load/unload.
 */

(function () {
  'use strict';

  const SELECTOR = '[data-custom-aos]';
  const CLASS_IN = 'custom-aos--in';

  /** @type {IntersectionObserver|null} */
  let observer = null;

  function createObserver() {
    if (observer) return observer;

    // Reduced motion - make everything visible immediately
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.add(CLASS_IN);
      });
      return null;
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(CLASS_IN);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0,
      }
    );

    return observer;
  }

  function observeElements(root) {
    var obs = createObserver();
    if (!obs) return;

    var container = root || document;
    container.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!el.classList.contains(CLASS_IN)) {
        obs.observe(el);
      }
    });
  }

  function init() {
    observeElements(document);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: observe new elements in loaded sections
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      // Reset animations in newly loaded section
      e.target.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.remove(CLASS_IN);
      });
      // Small delay to allow CSS transition from hidden state
      requestAnimationFrame(function () {
        observeElements(e.target);
      });
    });
  }
})();
